export default {
    '56aeaca6-a0ad-4548-8afc-94d8d4361ba1': {
        fieldId: '56aeaca6-a0ad-4548-8afc-94d8d4361ba1',
        fieldName: 'StandardContactField_GuestFirstName__resx',
        displayName: 'StandardContactField_GuestFirstName__resx',
        display: 2,
        isCustomField: false
    },
    'cfc98829-80b7-41b6-82b5-b968d43ef1c1': {
        fieldId: 'cfc98829-80b7-41b6-82b5-b968d43ef1c1',
        fieldName: 'StandardContactField_GuestLastName__resx',
        displayName: 'StandardContactField_GuestLastName__resx',
        display: 2,
        isCustomField: false
    },
    'ff919d05-4281-4d9c-aa0d-82e3722d580d': {
        fieldId: 'ff919d05-4281-4d9c-aa0d-82e3722d580d',
        fieldName: 'StandardContactField_GuestEmailAddress__resx',
        displayName: 'StandardContactField_GuestEmailAddress__resx',
        display: 1,
        isCustomField: false
    },
    'b84eefea-cf4c-4006-b69f-d144e601d272': {
        fieldId: 'b84eefea-cf4c-4006-b69f-d144e601d272',
        fieldName: 'StandardContactField_GuestPrefix__resx',
        displayName: 'StandardContactField_GuestPrefix__resx',
        display: 0,
        isCustomField: false
    },
    'ab2db8e3-59e8-4cf7-9bc7-a3f460081a3f': {
        fieldId: 'ab2db8e3-59e8-4cf7-9bc7-a3f460081a3f',
        fieldName: 'StandardContactField_GuestMiddleName__resx',
        displayName: 'StandardContactField_GuestMiddleName__resx',
        display: 0,
        isCustomField: false
    },
    '347aebe3-9099-42b9-8b6d-15200ae72842': {
        fieldId: '347aebe3-9099-42b9-8b6d-15200ae72842',
        fieldName: 'StandardContactField_GuestDesignation__resx',
        displayName: 'StandardContactField_GuestDesignation__resx',
        display: 0,
        isCustomField: false
    },
    '1b5e4084-0ee4-42de-817d-049b349187ac': {
        fieldId: '1b5e4084-0ee4-42de-817d-049b349187ac',
        fieldName: 'StandardContactField_GuestNickname__resx',
        displayName: 'StandardContactField_GuestNickname__resx',
        display: 0,
        isCustomField: false
    },
    '227f50d0-f65b-4a72-9a4f-5060ea05f6ab': {
        fieldId: '227f50d0-f65b-4a72-9a4f-5060ea05f6ab',
        fieldName: 'StandardContactField_GuestCompany__resx',
        displayName: 'StandardContactField_GuestCompany__resx',
        display: 1,
        isCustomField: false
    },
    '228cc308-a4d9-4212-8454-8407dd578c3d': {
        fieldId: '228cc308-a4d9-4212-8454-8407dd578c3d',
        fieldName: 'StandardContactField_GuestTitle__resx',
        displayName: 'StandardContactField_GuestTitle__resx',
        display: 1,
        isCustomField: false
    },
    '5b1f5ccc-6c46-4ce8-bc87-a40fab4e15cd': {
        fieldId: '5b1f5ccc-6c46-4ce8-bc87-a40fab4e15cd',
        fieldName: 'StandardContactField_GuestCCEmailAddress__resx',
        displayName: 'StandardContactField_GuestCCEmailAddress__resx',
        display: 0,
        isCustomField: false
    },
    'b468074b-b6a7-4149-8f97-e6b21b2ca8b3': {
        fieldId: 'b468074b-b6a7-4149-8f97-e6b21b2ca8b3',
        fieldName: 'StandardContactField_GuestDateofBirth__resx',
        displayName: 'StandardContactField_GuestDateofBirth__resx',
        display: 0,
        isCustomField: false
    },
    '93bf707b-924c-4dbf-908c-4311233d17ae': {
        fieldId: '93bf707b-924c-4dbf-908c-4311233d17ae',
        fieldName: 'StandardContactField_GuestGender__resx',
        displayName: 'StandardContactField_GuestGender__resx',
        display: 0,
        isCustomField: false
    },
    '0506ce9a-d038-409c-9d94-2ed9be273fba': {
        fieldId: '0506ce9a-d038-409c-9d94-2ed9be273fba',
        fieldName: 'StandardContactField_GuestPassportNumber__resx',
        displayName: 'StandardContactField_GuestPassportNumber__resx',
        display: 0,
        isCustomField: false
    },
    'bbe011f6-855c-41f2-ac1f-d1cbc6b15af8': {
        fieldId: 'bbe011f6-855c-41f2-ac1f-d1cbc6b15af8',
        fieldName: 'StandardContactField_GuestPassportCountry__resx',
        displayName: 'StandardContactField_GuestPassportCountry__resx',
        display: 0,
        isCustomField: false
    },
    '37c9b0d9-4362-476c-a841-60ce961a8cca': {
        fieldId: '37c9b0d9-4362-476c-a841-60ce961a8cca',
        fieldName: 'StandardContactField_GuestSocialSecurityNumber__resx',
        displayName: 'StandardContactField_GuestSocialSecurityNumber__resx',
        display: 0,
        isCustomField: false
    },
    '064d9032-4844-49db-815c-1a83ce2ab7ed': {
        fieldId: '064d9032-4844-49db-815c-1a83ce2ab7ed',
        fieldName: 'StandardContactField_GuestNationalIdentificationNumber__resx',
        displayName: 'StandardContactField_GuestNationalIdentificationNumber__resx',
        display: 0,
        isCustomField: false
    },
    'b5a8362f-91e7-46ff-a704-20bfb3ca6ce5': {
        fieldId: 'b5a8362f-91e7-46ff-a704-20bfb3ca6ce5',
        fieldName: 'StandardContactField_GuestWorkAddress__resx',
        displayName: 'StandardContactField_GuestWorkAddress__resx',
        display: 0,
        isCustomField: false,
        subFieldDisplayNames: {
            zip: 'Zip/Postal Code',
            country: 'Country',
            address3: '',
            address2: 'Address 2',
            city: 'City',
            address1: 'Address 1',
            state: 'State/Province'
        },
        defaultCountry: {
            name: '',
            value: ''
        }
    },
    'a57801cd-d76c-48a5-85a2-2cc63af84ee9': {
        fieldId: 'a57801cd-d76c-48a5-85a2-2cc63af84ee9',
        fieldName: 'StandardContactField_GuestHomePhone__resx',
        displayName: 'StandardContactField_GuestHomePhone__resx',
        display: 0,
        isCustomField: false
    },
    '032e80c1-f29f-44e6-af13-a89e53906422': {
        fieldId: '032e80c1-f29f-44e6-af13-a89e53906422',
        fieldName: 'StandardContactField_GuestMobile__resx',
        displayName: 'StandardContactField_GuestMobile__resx',
        display: 1,
        isCustomField: false
    }
};
